// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* @import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap"); */
.modalOverlay_YoYPh {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: var(--_00000020-background);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999999;
  transition: opacity 300ms ease-in-out;
}

.modalContent_XY1Qq {
  display: flex;
  flex-direction: column;
  background-color: var(--white-background);
  border-radius: 8px;
  /* box-shadow: 0 2px 10px var(--_0000001a-shadow); */
  width: 515px;
  transform: scale(1);
  animation: scaleUp_rEAZP 300ms ease-out forwards;
  font-family: "Inter", sans-serif;
  overflow: hidden;
  @media (width<=768px) {
    max-width: 100vw;
    width: 100vw;
    height: 100vh;
    max-height: 100vh;
    border-radius: 0;
    -webkit-border-radius: 0;
    -moz-border-radius: 0;
    -ms-border-radius: 0;
    -o-border-radius: 0;
  }
}

.scaleDown_xIBoH {
  animation: scaleDown_xIBoH 300ms ease-in forwards;
}

@keyframes scaleUp_rEAZP {
  from {
    transform: scale(0);
  }
  to {
    transform: scale(1);
  }
}

@keyframes scaleDown_xIBoH {
  from {
    transform: scale(1);
  }
  to {
    transform: scale(0);
    -webkit-transform: scale(0);
    -moz-transform: scale(0);
    -ms-transform: scale(0);
    -o-transform: scale(0);
}
}

.fadeOut_x_uqc {
  opacity: 0;
}

.headerLeft_jm66f {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: var(--_2-color);
  font-size: 20px;
  font-weight: 600;
  gap: 10px;
}
.closeIcon_gaijS {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 31px;
  height: 31px;
  cursor: pointer;
  border-radius: 4px;
  background: var(--f6-background);
  -webkit-user-select: none;
          user-select: none;
}

.footerContainer_RUVAT {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  padding: 0 24px;
  height: 64px;
  border-top: 1px solid var(--e3-border);
  gap: 16px;
}

.newFolderButton_eonel {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--_232222-color);
  padding: 12.5px 24px;
  border-radius: 8px;
  border: 1px solid var(--cb-border);
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  min-width: 80px;
}
.selectButton_th2xl {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--white-color);
  padding: 12.5px 24px;
  border-radius: 8px;
  background: var(--_10a37f-background);
  border: 1px solid var(--_10a37f-border);
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  min-width: 80px;
}

.contentContainer_jcTLh {
  display: flex;
  flex-direction: column;
  gap: 20px;
  background-color: var(--f5-background);
  padding: 0px 10px 10px;
  .content_XrznG {
    margin: 0 auto;
    width: 90%;
    background-color: var(--white-background);
    padding: 20px;
    gap: 20px;
    display: flex;
    flex-direction: column;
    border-radius: 14px;
    -webkit-border-radius: 14px;
    -moz-border-radius: 14px;
    -ms-border-radius: 14px;
    -o-border-radius: 14px;
  }
}

.contentInnerContainer_renaw {
  display: flex;
  flex-direction: column;
  gap: 5px;
  span {
    font-size: 16px;
    font-weight: 500;
    color: var(--_2-color);
  }
}


.label_JGnUT {
  font-size: 14px;
  font-weight: 500;
  color: var(--_0c1421-color);
  margin-bottom: 8px;
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.input_bC6t9 {
  display: flex;
  width: 100%;
  padding: 15px;
  border: none;
  border-radius: 12px;
  font-size: 14px;
  color: var(--_8897ad-color);
  border: none !important;
  outline: none !important;
  background-color: var(--f4-background);
  height: 48px;
  box-sizing: border-box;
}
.infoContainerWrapper_v5RZC {
  display: flex;
  align-items: center;
  gap: 22px;
  padding: 0;
  height: 45px;
}
.infoContainer_XEJQ4 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0;
  padding: 0;
  div {
    color: var(--_1f184b-color);
    font-size: 14px;
    font-weight: 600;
  }
  span {
    color: var(--_1f184b-color);
    font-size: 12px;
    font-weight: 300;
  }
}

.contentContainerWrapp_lrA2Z {
  width: 100%;
  justify-content: space-between;
  align-items: center;
  background-color: var(--f5-background);
  padding: 0px 18px;
  height: 32px;
  box-sizing: border-box;
  border-radius: 4px;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  -ms-border-radius: 4px;
  -o-border-radius: 4px;
  .inviteButton_wVEcv {
    cursor: pointer;
    font-weight: 600;
  }
  input {
    background-color: transparent;
    outline: none;
    border: none;
  }
  > div {
    width: fit-content;
  }
  &.active_tcNPS {
    display: flex;
  }
  &.disabled_hjcxZ {
    display: none;
  }
}
.errorMessage_BbBVv {
  color: var(--red-color);
  font-size: 13px;
}
.emailList_CNuUQ {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.emailItem_pIqUT {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
}
.nameEmail_ZBc00 {
  display: flex;
  align-items: center;
  gap: 10px;
  .logo_LlczQ {
    display: flex;
    align-items: center;
    justify-content: center;
    text-transform: uppercase;
    color: var(--white-color);
    background-color: var(--_233f39-background);
    height: 40px;
    width: 40px;
    border-radius: 4px;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    -ms-border-radius: 4px;
    -o-border-radius: 4px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/CreateFolderModal/CreateFolderModal.module.css"],"names":[],"mappings":"AAAA,qGAAqG;AACrG;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,6CAA6C;EAC7C,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yCAAyC;EACzC,kBAAkB;EAClB,oDAAoD;EACpD,YAAY;EACZ,mBAAmB;EACnB,gDAA0C;EAC1C,gCAAgC;EAChC,gBAAgB;EAChB;IACE,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,wBAAwB;IACxB,qBAAqB;IACrB,oBAAoB;IACpB,mBAAmB;EACrB;AACF;;AAEA;EACE,iDAA2C;AAC7C;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;IACnB,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;AAC1B;AACA;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gCAAgC;EAChC,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,YAAY;EACZ,sCAAsC;EACtC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,oBAAoB;EACpB,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,oBAAoB;EACpB,kBAAkB;EAClB,qCAAqC;EACrC,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,sCAAsC;EACtC,sBAAsB;EACtB;IACE,cAAc;IACd,UAAU;IACV,yCAAyC;IACzC,aAAa;IACb,SAAS;IACT,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;EACxB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR;IACE,eAAe;IACf,gBAAgB;IAChB,sBAAsB;EACxB;AACF;;;AAGA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,WAAW;EACX,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;EACvB,wBAAwB;EACxB,sCAAsC;EACtC,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,UAAU;EACV,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,MAAM;EACN,UAAU;EACV;IACE,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE,WAAW;EACX,8BAA8B;EAC9B,mBAAmB;EACnB,sCAAsC;EACtC,iBAAiB;EACjB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,6BAA6B;IAC7B,aAAa;IACb,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;AACF;AACA;EACE,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,WAAW;EACX,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,yBAAyB;IACzB,2CAA2C;IAC3C,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;EACvB;AACF","sourcesContent":["/* @import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap\"); */\n.modalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: var(--_00000020-background);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 999999;\n  transition: opacity 300ms ease-in-out;\n}\n\n.modalContent {\n  display: flex;\n  flex-direction: column;\n  background-color: var(--white-background);\n  border-radius: 8px;\n  /* box-shadow: 0 2px 10px var(--_0000001a-shadow); */\n  width: 515px;\n  transform: scale(1);\n  animation: scaleUp 300ms ease-out forwards;\n  font-family: \"Inter\", sans-serif;\n  overflow: hidden;\n  @media (width<=768px) {\n    max-width: 100vw;\n    width: 100vw;\n    height: 100vh;\n    max-height: 100vh;\n    border-radius: 0;\n    -webkit-border-radius: 0;\n    -moz-border-radius: 0;\n    -ms-border-radius: 0;\n    -o-border-radius: 0;\n  }\n}\n\n.scaleDown {\n  animation: scaleDown 300ms ease-in forwards;\n}\n\n@keyframes scaleUp {\n  from {\n    transform: scale(0);\n  }\n  to {\n    transform: scale(1);\n  }\n}\n\n@keyframes scaleDown {\n  from {\n    transform: scale(1);\n  }\n  to {\n    transform: scale(0);\n    -webkit-transform: scale(0);\n    -moz-transform: scale(0);\n    -ms-transform: scale(0);\n    -o-transform: scale(0);\n}\n}\n\n.fadeOut {\n  opacity: 0;\n}\n\n.headerLeft {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  color: var(--_2-color);\n  font-size: 20px;\n  font-weight: 600;\n  gap: 10px;\n}\n.closeIcon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 31px;\n  height: 31px;\n  cursor: pointer;\n  border-radius: 4px;\n  background: var(--f6-background);\n  user-select: none;\n}\n\n.footerContainer {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-end;\n  padding: 0 24px;\n  height: 64px;\n  border-top: 1px solid var(--e3-border);\n  gap: 16px;\n}\n\n.newFolderButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--_232222-color);\n  padding: 12.5px 24px;\n  border-radius: 8px;\n  border: 1px solid var(--cb-border);\n  font-size: 16px;\n  font-weight: 500;\n  cursor: pointer;\n  user-select: none;\n  min-width: 80px;\n}\n.selectButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--white-color);\n  padding: 12.5px 24px;\n  border-radius: 8px;\n  background: var(--_10a37f-background);\n  border: 1px solid var(--_10a37f-border);\n  font-size: 16px;\n  font-weight: 500;\n  cursor: pointer;\n  user-select: none;\n  min-width: 80px;\n}\n\n.contentContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  background-color: var(--f5-background);\n  padding: 0px 10px 10px;\n  .content {\n    margin: 0 auto;\n    width: 90%;\n    background-color: var(--white-background);\n    padding: 20px;\n    gap: 20px;\n    display: flex;\n    flex-direction: column;\n    border-radius: 14px;\n    -webkit-border-radius: 14px;\n    -moz-border-radius: 14px;\n    -ms-border-radius: 14px;\n    -o-border-radius: 14px;\n  }\n}\n\n.contentInnerContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  span {\n    font-size: 16px;\n    font-weight: 500;\n    color: var(--_2-color);\n  }\n}\n\n\n.label {\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--_0c1421-color);\n  margin-bottom: 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.input {\n  display: flex;\n  width: 100%;\n  padding: 15px;\n  border: none;\n  border-radius: 12px;\n  font-size: 14px;\n  color: var(--_8897ad-color);\n  border: none !important;\n  outline: none !important;\n  background-color: var(--f4-background);\n  height: 48px;\n  box-sizing: border-box;\n}\n.infoContainerWrapper {\n  display: flex;\n  align-items: center;\n  gap: 22px;\n  padding: 0;\n  height: 45px;\n}\n.infoContainer {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 0;\n  padding: 0;\n  div {\n    color: var(--_1f184b-color);\n    font-size: 14px;\n    font-weight: 600;\n  }\n  span {\n    color: var(--_1f184b-color);\n    font-size: 12px;\n    font-weight: 300;\n  }\n}\n\n.contentContainerWrapp {\n  width: 100%;\n  justify-content: space-between;\n  align-items: center;\n  background-color: var(--f5-background);\n  padding: 0px 18px;\n  height: 32px;\n  box-sizing: border-box;\n  border-radius: 4px;\n  -webkit-border-radius: 4px;\n  -moz-border-radius: 4px;\n  -ms-border-radius: 4px;\n  -o-border-radius: 4px;\n  .inviteButton {\n    cursor: pointer;\n    font-weight: 600;\n  }\n  input {\n    background-color: transparent;\n    outline: none;\n    border: none;\n  }\n  > div {\n    width: fit-content;\n  }\n  &.active {\n    display: flex;\n  }\n  &.disabled {\n    display: none;\n  }\n}\n.errorMessage {\n  color: var(--red-color);\n  font-size: 13px;\n}\n.emailList {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.emailItem {\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n  align-items: center;\n}\n.nameEmail {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  .logo {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-transform: uppercase;\n    color: var(--white-color);\n    background-color: var(--_233f39-background);\n    height: 40px;\n    width: 40px;\n    border-radius: 4px;\n    -webkit-border-radius: 4px;\n    -moz-border-radius: 4px;\n    -ms-border-radius: 4px;\n    -o-border-radius: 4px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalOverlay": `modalOverlay_YoYPh`,
	"modalContent": `modalContent_XY1Qq`,
	"scaleUp": `scaleUp_rEAZP`,
	"scaleDown": `scaleDown_xIBoH`,
	"fadeOut": `fadeOut_x_uqc`,
	"headerLeft": `headerLeft_jm66f`,
	"closeIcon": `closeIcon_gaijS`,
	"footerContainer": `footerContainer_RUVAT`,
	"newFolderButton": `newFolderButton_eonel`,
	"selectButton": `selectButton_th2xl`,
	"contentContainer": `contentContainer_jcTLh`,
	"content": `content_XrznG`,
	"contentInnerContainer": `contentInnerContainer_renaw`,
	"label": `label_JGnUT`,
	"input": `input_bC6t9`,
	"infoContainerWrapper": `infoContainerWrapper_v5RZC`,
	"infoContainer": `infoContainer_XEJQ4`,
	"contentContainerWrapp": `contentContainerWrapp_lrA2Z`,
	"inviteButton": `inviteButton_wVEcv`,
	"active": `active_tcNPS`,
	"disabled": `disabled_hjcxZ`,
	"errorMessage": `errorMessage_BbBVv`,
	"emailList": `emailList_CNuUQ`,
	"emailItem": `emailItem_pIqUT`,
	"nameEmail": `nameEmail_ZBc00`,
	"logo": `logo_LlczQ`
};
export default ___CSS_LOADER_EXPORT___;
